module.exports = __webpack_public_path__ + "img/award-03.d06608da.svg";